import type Survey from '../store/models/v2/Survey'

export const canEditSurvey = (survey: Survey, manageSurveys: boolean): boolean => {
  if (manageSurveys) {
    return true
  } else {
    const roles = survey.roles
    return roles.author || roles.supervisor
  }
}
